<template>
    <div class="container-fluid px-3 px-md-4 px-lg-5">
        <div class="row mt-2">
            <div class="col align-text-center">
                <img src="../assets/logo.png" alt="WebLungi logo" class="img-fluid app-logo">
            </div>
            <div class="col d-flex align-items-end">
                <h2>{{ $t('hello') }} {{ name }}</h2>
            </div>
            <div class="col-2 align-self-end">
                <LogoutButton />
            </div>
        </div>
        <div class="row">
            <ul class="nav nav-tabs" id="navigationTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane"
                        type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">{{
                    $t('tabheaders.general') }}</button>
                </li>
                <li v-if="isAdmin" class="nav-item" role="presentation">
                    <button class="nav-link" id="usertools-profile-tab" data-bs-toggle="tab"
                        data-bs-target="#usertools-tab-pane" type="button" role="tab" aria-controls="usertools-tab-pane"
                        aria-selected="false">{{ $t('tabheaders.user_tools') }}</button>
                </li>
                <li v-if="isAdmin" class="nav-item" role="presentation">
                    <button class="nav-link" id="grouptools-tab" data-bs-toggle="tab"
                        data-bs-target="#grouptools-tab-pane" type="button" role="tab"
                        aria-controls="grouptools-tab-pane" aria-selected="false">{{
                    $t('tabheaders.group_tools') }}</button>
                </li>
                <li v-if="isAdmin" class="nav-item" role="presentation">
                    <button class="nav-link" id="devicetools-tab" data-bs-toggle="tab"
                        data-bs-target="#devicetools-tab-pane" type="button" role="tab"
                        aria-controls="devicetools-tab-pane" aria-selected="false">{{ $t('tabheaders.device_tools')
                        }}</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="userinfo-tab" data-bs-toggle="tab" data-bs-target="#userinfo-tab-pane"
                        type="button" role="tab" aria-controls="userinfo-tab-pane" aria-selected="false">{{
                        $t('tabheaders.user_info') }}</button>
                </li>
            </ul>
            <div class="tab-content" id="navigationTabContent">
                <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab">
                    <slot name="home"></slot>
                </div>
                <div class="tab-pane fade" id="usertools-tab-pane" role="tabpanel" aria-labelledby="usertools-tab">
                    <slot name="usertools"></slot>
                </div>
                <div class="tab-pane fade" id="devicetools-tab-pane" role="tabpanel" aria-labelledby="devicetools-tab">
                    <slot name="devicetools"></slot>
                </div>
                <div class="tab-pane fade" id="grouptools-tab-pane" role="tabpanel" aria-labelledby="grouptools-tab">
                    <slot name="grouptools"></slot>
                </div>
                <div class="tab-pane fade" id="userinfo-tab-pane" role="tabpanel" aria-labelledby="userinfo-tab">
                    <slot name="userinfo"></slot>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import LogoutButton from './LogoutButton.vue';

export default {
    name: 'PageHeader',
    components: {
        LogoutButton
    },
    props: {
        name: {
            type: String,
            default: ''
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
    }
}
</script>

<style>
.app-logo {
    max-width: 180px;
    width: auto;
    height: auto;
}

@media (max-width: 576px) {
    .app-logo {
        max-width: 120px;
    }
}
</style>
